import { Column } from '../../../components/Table/Table';
import { NormalizedFCTransfer } from './SetupCheck';
import { useTranslation } from 'react-i18next';
import { formatNumber, pushEventToDataLayer } from '../../../core/helpers';
import { ReactComponent as InfoIcon } from '../../../icons/info-outline.svg';
import { GTMEvents } from '../../../core/constants';
import Button from '../../../components/Button';

interface Props {
  row: NormalizedFCTransfer;
  columns: Column<NormalizedFCTransfer>[];
  gridTemplateColumns: string;
  i: number;
  openModal: () => void;
  homeCountry: string | undefined;
}

export default function FCTransfersRow({
  row,
  columns,
  gridTemplateColumns,
  i,
  openModal,
  homeCountry,
}: Props) {
  const { t } = useTranslation();
  return (
    <div
      data-index={i}
      data-testid={`row-${i}`}
      className='Table__row pt-2 pb-3'
    >
      <div className='d-grid' style={{ gridTemplateColumns }}>
        {columns.map((c) => (
          <div
            key={c.field as string}
            className='Table__cell'
            data-testid={`row-${i}-${c.field}`}
          >
            {c.formatter ? c.formatter(row) : row[c.field]}
          </div>
        ))}
      </div>
      {homeCountry === row.country && (
        <div
          className='d-grid'
          style={{
            gridTemplateColumns: `minmax(64px, 160px) minmax(64px, 2fr)`,
          }}
        >
          <div className='Table__cell'></div>
          <div className='Table__cell'>
            <div className=''>
              {t('All')}&nbsp;
              <Button
                styling='naked-blue'
                onClick={() => {
                  pushEventToDataLayer(
                    GTMEvents.setup_check_fc_transfers_transactions_click
                  );
                  openModal();
                }}
              >
                {formatNumber(row.arrivals.total + row.departures.total)}{' '}
                {t('transactions')}
              </Button>
              &nbsp;
              <InfoIcon
                className='SetupCheck__info'
                style={{
                  marginTop: -2,
                }}
              />
              &nbsp;
              {t(
                'must be included into local *country* filing by tax advisor'
              ).replace('*country*', row.country)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
